import { oz } from '@weft/utils';
import { PriceTiersListSchema } from '../../../price-tier';

export const TiersPricingConfigurationSchema = oz.object({
  tiers: PriceTiersListSchema,
  isVolume: oz.boolean().optional().default(false),
  isFlatRate: oz.boolean().optional().default(false),
}).openapi('TiersPricingConfiguration');

export type TiersPricingConfiguration = oz.infer<typeof TiersPricingConfigurationSchema>;